import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import { PrintSingleProductionReceiving } from "./ProductionReceivingAction";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import MaterialSize from "material-table";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";
import PrintIcon from '@mui/icons-material/Print';


const ViewProductionReceiving = (props) => {

    useEffect(() => {
        props.setHeading("Receiving List");
    }, []);

    return (
        <>
            {props.isFetchingProductionReceiving ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <div className="main">
                        <MaterialSize
                            title="Receiving List"
                            columns={[
                                { title: "Order No", field: "orderDetails.orderNumber", editable: 'never' },
                                { title: 'Receiving No', field: 'sequenceNumber', editable: 'never' },
                                { title: "Vendor Name", field: "vendorDetails.vendorName", editable: 'never' },
                                { title: "Receiving Date", field: "issuanceDate" },
                                // { title: "Receiving Type", field: "issuanceType" },
                                { title: "Description", field: "description" },
                                { title: "Created By", field: "userDetails.userName", editable: 'never' },
                            ]}
                            data={(query) =>
                                new Promise((resolve, reject) => {
                                    let url = `${baseURL}/productionReceiving?`;
                                    url += "limit=" + query.pageSize;
                                    url += "&page=" + (query.page);
                                    url += "&search=" + query.search;
                                    fetch(url, {
                                        method: "GET",
                                        headers: headers,
                                    }).then((response) => response.json()).then((result) => {
                                        resolve({
                                            data: result.data,
                                            page: result.page,
                                            totalCount: result.total_results,
                                        });
                                    });
                                })
                            }
                            detailPanel={rowData => {
                                return (
                                    <MaterialTable
                                        columns={[
                                            { title: 'Article Name', field: 'articleName' },
                                            // { title: 'Order Quantity', field: 'orderQuantity' },
                                            { title: 'Receiving Quantity', field: 'recevingQuantity' },
                                            // { title: 'Process Name', field: 'processDetails.processName' },
                                            // { title: 'Process Rate', field: 'processDetails.processRate' },
                                        ]}
                                        data={rowData.orderDetails.articleIssuanceDetails}
                                        options={{
                                            actionsColumnIndex: -1,
                                            toolbar: false,
                                            exportButton: false,
                                            sorting: false,
                                            paging: false,
                                            pageSize: 50,
                                            emptyRowsWhenPaging: false,
                                            pageSizeOptions: [50, 100, 150, 200],
                                            headerStyle: {
                                                position: 'sticky',
                                                top: 0,
                                                color: '#00BBBB',
                                                fontWeight: '550',
                                                onRowAdd: 'none',
                                            }
                                        }}
                                    />
                                )
                            }}
                            options={{
                                actionsColumnIndex: -1,
                                exportButton: true,
                                exportAllData: true,
                                paging: true,
                                pageSize: 50,
                                emptyRowsWhenPaging: false,
                                pageSizeOptions: [50, 100, 150, 200],
                                headerStyle: {
                                    position: "sticky",
                                    top: 0,
                                    color: "#00BBBB",
                                    fontWeight: "550",
                                    onRowAdd: "none",
                                },
                            }}
                            editable={{
                                // isEditHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Edit"),
                                // isDeleteHidden: (rowData) => Checkpermissions("permissionsSubCatName", "Colour Delete"),
                                isDeletable: rowData => false,
                                isEditable: rowData => false,
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            props.UpdateProcessApi(newData, oldData);
                                        }, 600);
                                    }),
                                onRowDelete: (oldData) =>
                                    new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve();
                                            props.DeleteProcessApi(oldData._id);
                                        }, 600);
                                    }),
                            }}
                            actions={[
                                (rowData) => ({
                                    icon: () => <PrintIcon />,
                                    tooltip: "Print Receiving",
                                    onClick: (event, rowData) => {
                                        props.PrintSingleProductionReceiving(rowData)
                                    },
                                }),
                            ]}
                        />
                    </div>
                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        PrintSingleProductionReceiving: (data) => dispatch(PrintSingleProductionReceiving(data)),
        // DeleteProcessApi: (id) => dispatch(DeleteProcessApi(id)),
        // UpdateProcessApi: (newData, oldData) => dispatch(UpdateProcessApi(newData, oldData)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    productionReceivingList: state.ProductionReceivingReducer.productionReceivingList,
    isFetchingProductionReceiving: state.ProductionReceivingReducer.isFetchingProductionReceiving,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewProductionReceiving);